import { render, staticRenderFns } from "./DatePickerV1.vue?vue&type=template&id=fae66a4e&"
import script from "./DatePickerV1.vue?vue&type=script&lang=js&"
export * from "./DatePickerV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports